import React from "react";
import { Organization } from "@common/types/organization";
import { User } from "@common/types/user";
import { Extends } from "@common/helpers/typescript";
import { OnboardingLayout } from "../layout/OnboardingLayout";
import { OrganizationProfile } from "../steps/OrganizationProfile";
import { OnboardingStepKey } from "../steps";
import { useManageSteps } from "../useManageSteps";
import { Outro } from "../steps/Outro/Outro";

type OrganizationOnboardingFlowSteps = Extends<
    OnboardingStepKey,
    "organizationProfile" | "outro"
>;

interface Props {
    organization: Organization;
    user: User;
    onFinish: () => void;
}

export const OrganizationOnboardingFlow: React.FC<Props> = ({
    organization,
    user,
    onFinish,
}) => {
    const { go, currentStep, nextStep, isExiting } =
        useManageSteps<OrganizationOnboardingFlowSteps>(
            true,
            () => "organizationProfile",
        );

    let main: React.ReactNode;

    switch (currentStep) {
        case "organizationProfile":
            main = (
                <OrganizationProfile
                    organization={organization}
                    user={user}
                    onSubmit={() => go("outro")}
                />
            );
            break;
        case "outro":
            main = <Outro onFinished={onFinish} />;
            break;
    }
    return (
        <OnboardingLayout
            currentStep={currentStep}
            nextStep={nextStep}
            main={main}
            isExiting={isExiting}
        />
    );
};
